import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <div className="relative w-full md:max-w-xs">
    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground">
      <Search size={16} />
    </span>
    <Input
      className="search-bar w-full pl-10"
      placeholder={placeholder || 'Search Data Record Types'}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  </div>
);

export default SearchBar;
